module.exports = __webpack_public_path__ + "img/wp-existing-habit-card5.8d1c3113.jpg";